import { FC } from "react";
import { Badge, Card, CardContent, CardHeader } from "@mui/material";
import { CardFieldProps } from "../../utils/cardFields";
import star from "../../assets/images/star.png";
// import editIcon from "../../assets/images/actionIcon/edit.png";
import editIcon from "../../assets/svg/edit_icon.svg";
import deleteIcon from "../../assets/bin.png";
import blankUser from "../../assets/images/black_user.png";

const CardView: FC<CardFieldProps> = (props) => {
  const cardStyles = {
    border: props.border || "2px solid #C4CDD5", // Default border
    width: props.width || 345, // Default width
    height: props.height || "100%",
    maxHeight: props.maxHeight || "-webkit-fill-available",
    position: props.position || "relative",
    minWidth: "-webkit-fill-available",
  };

  const handleEditClick = () => {
    if (props?.onEditClick) {
      props.onEditClick(); // Call the onEditClick callback
    }
  };

  const handleDeleteClick = () => {
    if (props?.onDeleteClick) {
      props.onDeleteClick();
    }
  };

  return (
    <>
      <Card style={cardStyles}>
        {(props?.title || props?.template_name) && (
          <>
            {props?.isEdit && (
              <img
                src={editIcon}
                alt="img"
                style={{
                  width: "16px",
                  position: "absolute",
                  right: 4,
                  top: 6,
                  cursor: "pointer",
                }}
                onClick={handleEditClick} // Handle edit click
              />
            )}
            {props?.isDelete && (
              <img
                onClick={handleDeleteClick}
                src={deleteIcon}
                style={{
                  width: "16px",
                  position: "absolute",
                  right: 28,
                  top: 6,
                  cursor: "pointer",
                }}
                alt="delete"
              />
            )}
            <CardHeader
              sx={{ textAlign: "center", backgroundColor: "#e5f4f1" }}
              avatar={
                props.isStar ? ( // Check if star is true
                  <img src={star} alt="icons" />
                ) : null // Don't render an avatar if star is false or undefined
              }
              title={props?.title || props?.template_name}
            />
          </>
        )}
        {props?.isLogo && (
          <CardContent
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              display: "grid",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <img
              src={blankUser}
              style={{ width: "64px", marginBottom: "6px" }}
              alt="logo-icon"
            />
            {props?.name}
          </CardContent>
        )}
        {props?.name && (
          <CardContent
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              display: "block",
              alignItems: "center",
              padding: "10px 8px",
              textTransform: "capitalize",
            }}
          >
            {/* <AccountCircle sx={{ height: "20px", marginRight: "4px" }} />  */}
            <span style={{ color: "#637381", marginRight: "4px" }}>Name :</span>{" "}
            {props?.name}
          </CardContent>
        )}

        {props?.movingOn && (
          <CardContent
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              display: "block",
              justifyContent: "flex-start",
              padding: "10px",
            }}
          >
            <span style={{ color: "#637381", marginRight: "4px" }}>
              Moving On :
            </span>{" "}
            {props?.movingOn}
          </CardContent>
        )}
        {props?.packingOn && (
          <CardContent
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              display: "block",
              justifyContent: "flex-start",
              padding: "10px",
            }}
          >
            <span style={{ color: "#637381", marginRight: "4px" }}>
              Packing Start :
            </span>{" "}
            {props?.packingOn}
          </CardContent>
        )}
        {props?.followUp && (
          <CardContent
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              display: "block",
              justifyContent: "flex-start",
              padding: "10px",
            }}
          >
            <span style={{ color: "#637381", marginRight: "4px" }}>
              Follow Up :
            </span>{" "}
            {props?.followUp}
          </CardContent>
        )}

        {props?.contact_name && (
          <CardContent
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              display: "block",
              alignItems: "center",
              padding: "10px",
            }}
          >
            {/* <AccountBoxOutlined sx={{ height: "20px", marginRight: '4px',marginLeft:'-2px' }} />  */}
            <span style={{ color: "#637381", marginRight: "4px" }}>
              Contact Name :
            </span>{" "}
            {props?.contact_name}
          </CardContent>
        )}
        {props?.salutation && (
          <CardContent sx={{ fontSize: "12px", fontWeight: 600 }}>
            {props?.salutation}
          </CardContent>
        )}

        {props?.body && (
          <CardContent sx={{ fontSize: "11px", fontWeight: 600 }}>
            <div dangerouslySetInnerHTML={{ __html: props?.body }} />
          </CardContent>
        )}
        {props?.content && <CardContent>{props?.content}</CardContent>}
        {props?.phone && (
          <CardContent
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              display: "flex",
              alignItems: "center",
              padding: "10px",
              justifyContent: "space-between",
            }}
          >
            {/* <img
              src={call}
              alt="call-icon"
              style={{ height: "18px", marginRight: "8px",marginLeft:'1px' }}
            />{" "} */}
            <div>
              <span style={{ color: "#637381", marginRight: "4px" }}>
                Contact Number :
              </span>{" "}
              {props?.phone}
            </div>
            {props?.phoneDuplicateVal !== undefined &&
            props?.phoneDuplicateVal !== null &&
            props?.phoneDuplicateVal !== "null" &&
            props?.phoneDuplicateVal !== "" && <Badge
              badgeContent={props?.phoneDuplicateVal ? props?.phoneDuplicateVal : 1}
              color="primary"
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "11px",
                  height: "20px",
                  minWidth: "20px",
                  padding: "0 6px",
                  right: "6px",
                   zIndex: 0,
                   width:'max-content'
                },
              }}
            >
              <span />
            </Badge>
          }
          </CardContent>
        )}
        {props?.email && (
          <CardContent
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              display: "flex",
              alignItems: "center",
              padding: "10px",
              justifyContent: "space-between",
            }}
          >
            {/* <img
              src={email}
              alt="email-icon"
              style={{ height: "20px", marginRight: "6px",marginLeft:'1px' }}
            />{" "} */}
            <div>
              <span style={{ color: "#637381", marginRight: "4px" }}>
                Email :
              </span>{" "}
              {props?.email}
            </div>
            {props?.emailDuplicateVal !== undefined &&
            props?.emailDuplicateVal !== null &&
            props?.emailDuplicateVal !== "null" &&
            props?.emailDuplicateVal !== "" && <Badge
              badgeContent={props?.emailDuplicateVal ? props?.emailDuplicateVal : 1}
              color="primary"
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "11px",
                  height: "20px",
                  minWidth: "20px",
                  padding: "0 6px",
                  right: "6px",
                  zIndex: 0,
                   width:'max-content'
                },
              }}
            >
              <span />
            </Badge>
          }
          </CardContent>
        )}
        {props?.sales && (
          <CardContent
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              display: "block",
              alignItems: "center",
              padding: "10px",
            }}
          >
            {/* <img
              src={email}
              alt="email-icon"
              style={{ height: "20px", marginRight: "6px",marginLeft:'1px' }}
            />{" "} */}
            <span style={{ color: "#637381", marginRight: "4px" }}>
              Sales Person :
            </span>{" "}
            {props?.sales}
          </CardContent>
        )}
        {props.children}
      </Card>
    </>
  );
};

export default CardView;
